export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Clear = 'clear',
}

/**
 * Types of result response.
 */
export enum Result {
  Success = 'success',
  Error = 'error',
}
